import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAdmin } from "./AdminContext";
import { apiError } from "./api";

export default function AdminLogin() {
  const { user, login } = useAdmin();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(apiError(err, "Could not sign in. Please try again."));
    } finally {
      setBusy(false);
    }
  };

  const inputCls = "w-full border border-ivory/20 bg-white/5 px-4 py-3.5 text-sm text-ivory placeholder:text-ivory/40 focus:border-ivory focus:outline-none";

  return (
    <div className="flex min-h-screen items-center justify-center bg-charcoal px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-ivory/10 bg-[#242424] p-10">
        <div className="flex flex-col items-center">
          <img src="/logo.png" alt="PNG Landed Excellence" className="h-12 w-auto" />
          <h1 className="mt-6 font-serif text-2xl text-ivory">Admin sign in</h1>
          <p className="mt-2 text-center text-xs text-ivory/50">Property management for Andy and the PNG team.</p>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label htmlFor="admin-email" className="eyebrow mb-2 block text-ivory/60">Email</label>
            <input id="admin-email" type="email" data-testid="admin-login-email" className={inputCls} placeholder="you@pnglandedexcellence.com" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
          </div>
          <div>
            <label htmlFor="admin-password" className="eyebrow mb-2 block text-ivory/60">Password</label>
            <input id="admin-password" type="password" data-testid="admin-login-password" className={inputCls} placeholder="Your password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
          </div>
          {error && (
            <p className="border-l-2 border-brand pl-3 text-sm text-ivory" data-testid="admin-login-error">{error}</p>
          )}
          <button type="submit" disabled={busy} data-testid="admin-login-submit" className="flex w-full items-center justify-center gap-2 bg-brand px-6 py-4 text-sm font-semibold uppercase tracking-[0.18em] text-ivory hover:bg-brand-dark disabled:opacity-60">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
            Sign in securely
          </button>
          <p className="text-center text-[0.7rem] text-ivory/40">Forgot your password? Ask Andy to reset it from Team &amp; Access.</p>
        </form>
      </div>
    </div>
  );
}
